import Vue from 'vue'
import DashboardPlugin from './plugins/dashboard-plugin'
import App from './App.vue'
import router from './routes/router'
import axios from 'axios'
import VueYandexMetrika from 'vue-yandex-metrika'

Vue.prototype.$http = axios
Vue.use(DashboardPlugin)

Vue.use(VueYandexMetrika, {
  id: 69997624,
  router: router,
  env: process.env.NODE_ENV,
  options: {
    clickmap: true,
    webvisor: true
  }
})

new Vue({
  el: '#app',
  render: h => h(App),
  router
})
